module.exports = __webpack_public_path__ + "img/waimai.99fc56b6.png";